import { styled } from "@mui/material/styles";

export const ItemsWrapper = styled("div", {
  label: "items-wrapper",
})`
  ${({ theme }) => theme.breakpoints.up("md")} {
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
`;
